module.exports = __webpack_public_path__ + "img/systemDcFlow.49b78b0a.gif";